<template>
  <div v-bind:class="{'wide-panel': bindEmail}">
    <GSLabelHighlight
      class="verify-description"
      :text="getDescriptionText()"
      :highlitedText="getHighlightedText()"
      :delimiter="getDescriptionDelimiter()"
    ></GSLabelHighlight>
    <div v-if="bindPhone">
      <GSInputButton
        :placeholder="$t('lbl__input_verification_code')"
        :text="resendButtonText"
        :buttonDisabled="resendDisabled"
        @clicked="resend"
        @changed="updateInputOtp"
      ></GSInputButton>
      <!-- submit phone verification code -->
      <GSButton
        class="submit-button"
        :text="$t('btn__submit')"
        @clicked="submit"
      ></GSButton>
    </div>
    <GSSplitView v-if="bindEmail">
      <div slot="left">
        <div class="verify-content">
          <GSInputButton
            :placeholder="$t('lbl__input_verification_code')"
            :text="resendButtonText"
            :buttonDisabled="resendDisabled"
            @clicked="resend"
            @changed="updateInputCode"
          ></GSInputButton>
        </div>
        <!-- submit email verification code -->
        <GSButton
          class="submit-button"
          :text="$t('btn__submit')"
          @clicked="submit"
        ></GSButton>
      </div>
      <div slot="right">
        <div class="verify-content">
          <GSLabel :text="$t('lbl__clicked_link_in_email')"></GSLabel>
        </div>
        <!-- submit email continue -->
        <GSButton
          class="submit-button"
          :text="$t('btn__continue')"
          @clicked="email_continue"
        ></GSButton>
      </div>
    </GSSplitView>
    <GSAgreement
      :text="$t('lbl__user_agreement_{privacy_policy}')"
      :privacyPolicy="$t('lbl__privacy_policy')"
      @clicked="showPolicyPopup"
    ></GSAgreement>
  </div>
</template>

<script>
import GSLabel from '@/components/GSLabel.vue'
import GSLabelHighlight from '@/components/GSLabelHighlight'
import GSInputButton from '@/components/GSInputButton'
import GSButton from '@/components/GSButton'
import GSSplitView from '@/components/GSSplitView'
import GSAgreement from '@/components/GSAgreement'

import ApiUrlMixin from './mixins/ApiUrlMixin'
import BindBaseMixin from './mixins/BindBaseMixin'
import CountdownMixin from './mixins/CountdownMixin'
import RequestMixin from './mixins/RequestMixin'
import { EVENT } from '@/constants/event'

export default {
  name: 'VerifyPage',
  mixins: [ApiUrlMixin, BindBaseMixin, CountdownMixin, RequestMixin],
  data () {
    return {
      resendDisabled: true,
      resendCooldownTime: 60
    }
  },
  created () {
    let verifyTimestamp = this.$store.getters['bind/verifyTimestamp']
    if (verifyTimestamp > 0) {
      let diff = (Date.now() / 1000 | 0) - verifyTimestamp
      if (diff <= this.resendCooldownTime) {
        this.countdownReset(this.resendCooldownTime - diff, this.enableResend)
      } else {
        this.enableResend()
      }
    } else {
      // already verified, freeze page
      this.$emit(EVENT.SHOW_WARNING, this.$t('error__expired'), false)
    }
  },
  methods: {
    getDescriptionText () {
      return this.bindPhone
        ? this.$t('lbl__phone_verification_instruction_{phone}')
        : this.$t('lbl__email_verification_instruction_{email}')
    },
    getDescriptionDelimiter () {
      return this.bindPhone
        ? '{phone}'
        : '{email}'
    },
    getHighlightedText () {
      return this.bindPhone
        ? this.getDisplayPhoneNumber()
        : this.getDisplayEmailAddress()
    },
    updateInputOtp (val) {
      this.$store.commit('bind/updateInputOtp', val)
    },
    updateInputCode (val) {
      this.$store.commit('bind/updateInputCode', val)
    },
    showPolicyPopup () {
      this.$emit('show-policy')
    },
    submit () {
      let bindType = this.$route.params.type
      let phoneOtp = this.$store.state.bind.otp
      let emailCode = this.$store.state.bind.code
      if ((this.bindPhone && this.validatePhoneOtp(phoneOtp)) ||
        (this.bindEmail && this.validateEmailCode(emailCode))) {
        this.request('get',
          this.getBindApiUrl(bindType, 'verify'), {
            access_token: this.$store.getters['bind/requestParams'].access_token,
            ...this.getServerRoleClientParams(),
            otp: phoneOtp,
            code: emailCode
          }, () => {
            this.redirectToBindStep('success')
          })
      } else {
        this.$emit(EVENT.SHOW_WARNING, this.$t('error__wrong_verification_code'))
      }
    },
    email_continue () {
      this.request('get',
        this.getApiUrl('query'), {
          access_token: this.$store.getters['bind/requestParams'].access_token,
          ...this.getServerRoleClientParams()
        }, (data) => {
          if (data.email === this.getDisplayEmailAddress()) {
            this.redirectToBindStep('success')
          } else {
            this.$emit(EVENT.SHOW_WARNING, this.$t('error__cannot_continue'))
          }
        })
    },
    enableResend () {
      this.resendDisabled = false
    },
    resend () {
      let bindType = this.$route.params.type
      this.request('get', this.getBindApiUrl(bindType, 'resend'), {
        ...this.$store.getters['bind/requestParams']
      }, () => {
        this.resendDisabled = true
        this.$store.commit('bind/setVerifyTimestamp')
        this.countdownReset(this.resendCooldownTime, this.enableResend)
      })
    }
  },
  computed: {
    resendButtonText () {
      return this.$t('btn__resend') +
        (this.countdownCurrent > 0 ? ` (${this.countdownCurrent})` : '')
    }
  },
  components: {
    GSLabel,
    GSLabelHighlight,
    GSInputButton,
    GSButton,
    GSSplitView,
    GSAgreement
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars/base';

.wide-panel {
  max-width: $base-size * 1200;
}

.verify-description {
  margin: $base-size * 80 0 $base-size * 50 0;
}

.verify-content {
  height: $base-size * 120;
}

.submit-button {
  margin-top: $base-size * 30;
}
</style>



// WEBPACK FOOTER //
// src/pages/bind/VerifyPage.vue